<template>
    <div >
        <el-card class="detail-card">
            <ul>
                <li>
                    <p v-show="status=='服务台'&&canIEdit==true"><el-button type="primary" @click="appointFn('转一线')">转一线</el-button></p>
                    <p v-show="(status == '一线'||status=='服务台')&&canIEdit==true"><el-button type="primary" @click="appointFn('转二线')">转二线</el-button></p>
                    <p v-show="status=='服务台'&&recoverEdit==true"><el-button type="primary" @click="recallEvent('撤回')">撤回</el-button></p>
                    <p v-show="status == '二线'&&canIEdit==true"><el-button type="primary" @click="appointFn('转三线')">转三线</el-button></p>
                    <p v-show="status == '二线'&&canIEdit==true"><el-button type="primary" @click="appointFn('转第三方')">转第三方</el-button></p>
                    <p v-show="status == '三线'&&canIEdit==true"><el-button type="primary" @click="appointFn('转第三方')">转第三方</el-button></p>
                    <p v-show="status!='待评价'&&status!='创建'&&status!='处理完成'&&canIEdit==true"><el-button type="primary" @click="appointFn('驳回')">驳回</el-button></p>
                    <p v-show="status=='创建'&&canIEdit==true"><el-button type="primary" @click="deliver('提交')">提交</el-button></p>
                    <p v-show="status == '待评价'&&showEvaluation==true&&detail.isVisit==false">
                        <router-link :to="{ path: '/clientVisit',query:{ serialNumber:serialNumber,callback:getDetail}}">
                            <el-button type="primary">客户评价</el-button>
                        </router-link>
                    </p>
                    <p v-show="status!='创建'&&status!='待评价'&&status!='处理完成'&&canIEdit==true">
                        <router-link :to="{ path: '/ProcessingComplete',query:{ serialNumber:serialNumber,callback:getDetail }}">
                            <el-button type="primary">处理完成</el-button>
                        </router-link>
                    </p>
                    <p>
                        <router-link :to="{ path: '/flowChart',query:{ serialNumber:serialNumber}}">
                            <el-button type="primary">流程跟踪</el-button>
                        </router-link>
                    </p>
                    <p v-show="status !== '待评价'&&status!='处理完成'&&canIEdit==true"><el-button type="primary" @click="toEventUpdate">编辑</el-button></p>
                    <p  v-show="status!='服务台'&&status!='待评价'&&status!='处理完成'&&canIEdit==true"><el-button type="primary" @click="appointFn('转交')"  v-w-role="'ITSM-0250'">转交</el-button></p>

                </li>
                <li>
                    <el-row>
                        <router-link  :to="{ path:'/eventAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                            <el-button type="primary" v-w-role="'ITSM-0214'">创建子事件</el-button>
                        </router-link>
                        <router-link  :to="{ path:'/changeAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                        <el-button type="primary" v-w-role="'ITSM-0215'">提交为变更</el-button>
                        </router-link>
                        <router-link  :to="{ path:'/problemAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                            <el-button type="primary" v-w-role="'ITSM-0216'">提交为问题</el-button>
                        </router-link>
                        <router-link  :to="{ path:'/deployAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                            <el-button type="primary" v-w-role="'ITSM-0217'">提交为发布</el-button>
                        </router-link>
                    </el-row>
                </li>
            </ul>
            <el-row>
                <el-col :span="6"><label>编号：</label>{{ detail.serialNumber }}--{{detail.status | tableVal(eventStatus) }}</el-col>
                <el-col :span="18"><label>标题：</label>{{ detail.title }}</el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><label>请求人：</label>{{ detail.requester}}</el-col>
                <el-col :span="18"><label>逾期时间：</label>{{ detail.plannedCompleteTime }}</el-col>
            </el-row>
        </el-card>
        <div class="tab-card">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index">
                    <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>
                    <keep-alive v-if="!loading">
                        <component :is="currentView"
                                   :detail="detail"
                                   :companyList="companyList"
                                   :eventList="eventList"
                                   :problemList="problemList"
                                   :changeList="changeList"
                                   :deployList="deployList"
                                   :hotFAQ="hotFAQ"
                                   :serialNumber="serialNumber"
                                   :callback="getDetail"

                        ></component>
                    </keep-alive>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    import services from "./event.service";
    import detailForm from "../common/detail/detailForm.vue";                      // 表单明细
    import detailHandle from "../common/detail/detailHandle.vue";                  // 处理明细
    import WorkHours from "../common/detail/detailWorkHours.vue";                  // 工时/成本
    import SolveProject from "../common/detail/detailSolveProject.vue";            // 解决方案
    import HistoricRecords from "../common/detail/detailHistoricRecords.vue";      // 历史记录
    import HistoricNews from "../common/detail/detailHistoricNews.vue";            // 历史消息
    import detailKnowledge from "../common/detail/detailKnowledge.vue";            // 推荐知识
    import RelevancyEvent from "../common/detail/detailRelevancyEvent.vue";        // 关联事件
    import RelevancyQue from "../common/detail/detailRelevancyQue.vue";            // 关联问题
    import RelevancyChange from "../common/detail/detailRelevancyChange.vue";      // 关联变更
    import RelevancyIssue from "../common/detail/detailRelevancyIssue.vue";        // 关联发布
    import RelevancyConfig from "../common/detail/detailRelevancyConfig.vue";      // 关联配置项
    import RelevancyService from "../common/detail/detailRelevancyService.vue";    // 关联服务


    export default {
        name:"eventDetail",
        components:{
            detailForm,
            detailHandle,
            WorkHours,
            SolveProject,
            HistoricRecords,
            HistoricNews,
            detailKnowledge,
            RelevancyEvent,
            RelevancyQue,
            RelevancyChange,
            RelevancyConfig,
            RelevancyService,
            RelevancyIssue
        },
        computed:{
            currentView(){
                return this.tabViews[this.index].index;
            },
            query:function () {
                return this.$route.query
            },
            serialNumber:function () {
                return this.query.serialNumber
            },
            dictionary(){
                return this.$store.state.dictionary;
            },
            eventStatus(){
                return this.dictionary.event_status;
            },
            // 事件分类id
            eventType(){
                return this.$store.state.caseType.event;
            },
            // 问题分类id
            problemType(){
                return this.$store.state.caseType.problem;
            },
            // 变更分类id
            changeType(){
                return this.$store.state.caseType.change;
            },
            // 发布分类id
            deployType(){
                return this.$store.state.caseType.deploy;
            },
            user(){
                return window.localStorage.getItem('internalUserid')
            },
            //登陆的用户角色类型:超管、服务台组、普通用户
            userRole(){
                return window.localStorage.getItem('userRole')
            },
            pages(){
                return this.$store.state.tabView.pages
            },

        },
        watch:{
            '$route'(to,from){
                if (to.query.serialNumber != from.query.serialNumber){
                    this.sn = to.query.serialNumber
                    this.getDetail()
                }
            }
        },
        data() {
            return {
                detail:{},
                index:0,
                loading:true,
                activeName:"detailForm",
                tabViews:[
                    { name:"表单明细",index:"detailForm"},
                    { name:"处理明细",index:"detailHandle"},
                    { name:"工时",index:"WorkHours"},
                    { name:"解决方案",index:"SolveProject"},
                    { name:"历史记录",index:"HistoricRecords"},
                    { name:"历史消息",index:"HistoricNews"},
                    { name:"推荐知识",index:"detailKnowledge"},
                    { name:"关联事件",index:"RelevancyEvent"},
                    { name:"关联问题",index:"RelevancyQue"},
                    { name:"关联发布",index:"RelevancyIssue"},
                    { name:"关联变更",index:"RelevancyChange"},
                    { name:"关联配置项",index:"RelevancyConfig"},
                    { name:"关联服务",index:"RelevancyService"},

                ],
                status:"",   // 状态
                companyList:[],
                eventList:[],
                problemList:[],
                changeList:[],
                deployList:[],
                hotFAQ:[],
                allDetail:{},  //请求到的未经处理的所有详情数据
                showEvaluation:false,  //控制客户评价按钮是否出现
                canIEdit: false,
                recoverEdit:false,

            }
        },
         created() {
             if (this.$route.query) {
                this.sn = this.$route.query.serialNumber
            }
            this.getDetail();
            this.getCompanyList();
            this.getEventList();
            this.getProblemList();
            this.getChangeList();
            this.getDeployList();

        },

        methods: {
            getDetail(){
                // this.init();
                if (this.userRole=='super'){
                        this.canIEdit=true
                        this.recoverEdit = true
                }else{
                this.canIEdit=false
                this.recoverEdit = false
                }
                services.detail({ serialNumber:this.serialNumber}).then(res => {
                    this.allDetail={...res}
                    this.allDetail.requester = this.allDetail.requester ? this.allDetail.requester.name : "";
                    this.allDetail.createUser = this.allDetail.createUser ? this.allDetail.createUser.name : "";

                    this.detail =  {...res};
                    this.detail.requester = this.detail.requester ? this.detail.requester.name : "";
                    this.detail.createUser = this.detail.createUser ? this.detail.createUser.name : "";
                    this.detail.solutionUser = this.detail.solutionUser ? this.detail.solutionUser.name : "";
                    this.detail.updateUser = this.detail.updateUser ? this.detail.updateUser.name : "";
                    this.detail.designator = this.detail.designator ? this.detail.designator.name : "";
                    this.detail.currentHandler = this.detail.currentHandler ? this.detail.currentHandler.name : "";

                    res.currentHandler.internalUserid&&res.currentHandler.internalUserid==this.user?this.canIEdit=true:''

                    res.requester.internalUserid&&res.requester.internalUserid == this.user?this.recoverEdit=true:''

                    this.status = this.getNameById(res.status,this.eventStatus);

                    if (this.status=='创建'&& res.requester.internalUserid == this.user){
                        this.canIEdit=true
                    }
                    if (this.status=='服务台'&& res.requester.internalUserid == this.user){
                        this.recoverEdit=true
                    }
                    if (this.status=='服务台'&&this.userRole=='reception'){
                        this.canIEdit=true
                    }
                    this.search();
                    //判断客户评价按钮是否能出现
                    this.ifShowEvaluation()
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            //判断客户评价按钮是否能出现
            ifShowEvaluation(){
                let username =window.localStorage.getItem('name')
                let createUser=this.allDetail.createUser
                let requester=this.allDetail.requester
                if (username==createUser||username==requester){
                    this.showEvaluation=true
                }

            },
            // 获取所属公司列表
            getCompanyList(){
                commonService.companyList().then(res => {
                    this.companyList = res.list;
                })
            },
            // 获取事件分类
            getEventList(){
                commonService.categoryList(this.eventType.id).then(res => {
                    this.eventList = res;
                })
            },
            // 获取问题分类
            getProblemList(){
                commonService.categoryList(this.problemType.id).then(res => {
                    this.problemList = res;
                })
            },
            // 获取变更分类
            getChangeList(){
                commonService.categoryList(this.changeType.id).then(res => {
                    this.changeList = res;
                })
            },
            // 获取发布分类
            getDeployList(){
                commonService.categoryList(this.deployType.id).then(res => {
                    this.deployList = res;
                })
            },
            search(){//默认查询
                services.getKnowledgeList({"Query":this.detail.title,"pageIndex":1,"pageSize":5}).then(res=>{
                    this.hotFAQ = res.KnowledgeTable;
                })
            },
            // 撤回
            recallEvent(val){
                this.$confirm('您确定要撤回吗?', '撤回', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    let params = {
                        serialNumber:this.serialNumber,
                        handle: val
                    }
                    commonService.eventHandle(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '撤回成功!'
                        });
                        this.getDetail()
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消撤回'
                  });
                });
            },
            // 指派
            appointFn(val){
                this.$router.push({
                    path: '/appoint',
                    name: "appoint",
                    query: {
                        type:val,
                        serialNumber:this.serialNumber,
                        callback:this.getDetail
                    }
                })
            },
            // 编辑
            toEventUpdate(){
                this.$router.push({
                    path: '/eventAdd',
                    name: "eventAdd",
                    query: {
                        type:'edit',
                        serialNumber:this.serialNumber,
                        callback:this.getDetail
                    }
                })
            },
            // 挂起 | 取消挂起 | 待评价
            handle(str){
                let handle = str == "stop" ? "挂起" : "取消挂起";
                this.openMessage("您确定要"+ handle + "吗", '确定', () => {
                    let params = {
                        serialNumber:this.serialNumber,
                        handle:handle,
                    };
                    services.handle(params).then(res => {
                        this.$message.success(handle+"成功");
                        this.getDetail();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            updateSla(){
                this.openMessage("您确定要更新SLA吗", '确定', () => {
                    let params = {
                        serialNumber:this.serialNumber,
                    };
                    services.updateSla(params).then(res => {
                        this.$message.success("更新SLA成功");
                        this.getDetail();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            deliver(text){
                this.openMessage('您确定要提交到服务台吗？', '确定', () => {
                    commonService.eventHandle({ handle:text,serialNumber:this.serialNumber }).then(res => {
                        this.$message.success("提交成功");
                        // this.canIEdit=false
                        this.getDetail();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            //待评价
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleClick(tab, event){
                this.index = tab.index;
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .zebra-item{
        span{
            padding-right: 10px;
        }
    }
    .el-button--mini{
        margin: 0 10px;
    }
</style>
